export enum ObjectFieldCellType {
  TEXT = 'TEXT',
  RADIO = 'RADIO',
  TOGGLE = 'TOGGLE',
  CHECKBOX = 'CHECKBOX'
}

export interface ObjectFieldsRawMetaData {
  success: boolean;
  data: {
    column_configs: {
      [key: string]: {
        name: string;
        display_name: string;
        description: string;
        is_editable: boolean;
        order: number;
        type: string;
      };
    };
    object_configs: {
      [key: string]: {
        additional_config: {
          [key: string]: {
            display_name: string;
          };
        };
        is_editable: boolean;
        display_name: string;
      };
    };
  };
}

export interface ObjectFieldColumnConfig {
  name: string;
  displayName: string;
  description: string;
  isEditable: boolean;
  order: number;
  type: ObjectFieldCellType;
}

export interface ObjectConfigOptionTypeOption {
  value: string;
  label: string;
  description?: string;
}

export interface ObjectFieldsMetaObjectConfig {
  key: string;
  displayName: string;
  isEditable: boolean;
  options: ObjectConfigOptionTypeOption[];
}

export interface ObjectFieldsMetaData {
  columnConfigs: ObjectFieldColumnConfig[];
  objectConfigs: ObjectFieldsMetaObjectConfig[];
}
